var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('Header',{attrs:{"title":"O nás","subtitle":"Firma vznikla v roku 1993 a v súčastnosti sa zaoberáme:"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }